import * as React from 'react';

import { PropertyTripSummary } from '@shared-ui/lodging-property-offers/';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const TripSummaryWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => (
  <UitkSpacing margin={{ blockstart: 'three', blockend: 'three' }}>
    <PropertyTripSummary inputs={inputs} skipSsr={true} />;
  </UitkSpacing>
);

TripSummaryWrapper.displayName = 'SharedUiTripSummary';

export const SharedUiTripSummaryWrapper = withSharedUiPropertyOffers(TripSummaryWrapper);
